"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function isPresent(value) {
    return !(0, lodash_1.isEmpty)(value);
}
exports.default = isPresent;
